var React = require('react');

function IconSendMessage (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.7071 1.29289C22.9788 1.56453 23.0708 1.96776 22.9439 2.33035L15.9439 22.3304C15.8168 22.6933 15.4929 22.9513 15.1108 22.9939C14.7286 23.0364 14.3558 22.8561 14.152 22.53L9.27433 14.7257L1.47002 9.848C1.14393 9.64419 0.963587 9.27145 1.00617 8.88927C1.04875 8.50709 1.30671 8.18318 1.66967 8.05614L21.6697 1.05614C22.0323 0.929237 22.4355 1.02126 22.7071 1.29289ZM11.2696 14.1446L14.7442 19.7039L19.6085 5.80569L11.2696 14.1446ZM18.1943 4.39147L4.29615 9.25584L9.85543 12.7304L18.1943 4.39147Z","fill":"currentColor"}));
}

IconSendMessage.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconSendMessage;

IconSendMessage.default = IconSendMessage;
